import { useState, useEffect, Fragment } from 'react';
import { useStore } from '@nanostores/react';
import { isCartOpen, cartData } from '@stores/cartStore.js';
import parse from 'html-react-parser';

import Expert from './Expert.jsx';
import Carousel from '@components/Slider/Carousel.jsx';

import babyCategories from '../../data/baby_categories_new.json';

import { createCart, addToCart } from '@api/shopify.js';

import { chord } from '@api/chord.js';
import { isFutureDate, isEmpty } from '@utils/utils';
import ClassesAccordion from '../Accordion/ClassesAccordion.jsx';
import { c } from '../../data/navdata.js';

const BOOST_URL =
	'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&q=';

const ClassesProduct = ({ productData, slug }) => {
	const $cartData = useStore(cartData);

	const initialMeta = {
		isMain: false,
		comingSoon: false,
		freePurchase: false,
		freeSelect: false,
		paidExternal: false,
		oneOff: false,
		IGLive: false,
		noReg: false,
		isEvent: false,
		inPerson: false,
		inPersonLocation: '',
		inPersonVenue: '',
		inPersonAddress: '',
		inPersonAddress2: '',
		inPersonCity: '',
		inPersonState: '',
		inPersonZip: '',
		virtual: false,
		isSeries: false,
		seriesStartDate: '',
		seriesEndDate: '',
		meetingDate: '',
		meetingDateTime: '',
		dateTimeString: '',
		meetingDateTimeFormatted: '',
		untilDateTime: '',
		dayOfWeek: '',
		duration: '1 hour',
		meetingUrl: '',
		meetingId: '',
		profilePage1: '',
		profilePage2: '',
	};

	let initialTimeOptions = {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		// timeZoneName: 'short',
		// timeZone: 'America/Chicago',
	};

	const [productMeta, setProductMeta] = useState(initialMeta);
	const [timeOptions, setTimeOptions] = useState(initialTimeOptions);

	const [selectedClass, setSelectedClass] = useState({});

	const products = productData?.products;

	let isSeriesProduct = false;

	let classEventProducts = products?.filter((p) => {
		return p.product_type === 'Classes + Events';
	});

	const mainProduct = classEventProducts?.filter((p) => {
		return (
			p.title.indexOf('[hidden]') && p.tags?.indexOf('class-event-main')
		);
	})[0];

	//

	classEventProducts = classEventProducts?.filter((p) => {
		const productSlug = p.handle.split('_')[0];

		//
		return productSlug === slug;
	});

	//

	// classEventProducts = [...classEventProducts, mainProduct]

	const now = Date.now();
	//

	let futureClassEvents = classEventProducts?.filter((p) => {
		const metafields = p?.metafields?.filter((m) => {
			return m.namespace === 'meeting' && m.key === 'json';
		});

		const metafieldsJson =
			metafields?.length > 0 ? JSON.parse(metafields[0].value) : {};

		//

		const meetingDateTime = metafieldsJson.meeting_date_time || '';
		const untilDateTime = metafieldsJson.until_date_time || '';

		//

		const isOneOff = metafieldsJson.one_off || false;
		const isSeries = metafieldsJson.is_series || false;

		//

		const localMeetingDateTime = new Date(meetingDateTime).toLocaleString(
			'en-US',
			timeOptions
		);

		//

		const localUntilDateTime = new Date(untilDateTime).toLocaleString(
			'en-US',
			timeOptions
		);

		const localMeetingDateTimestamp = new Date(meetingDateTime).getTime();
		const localUntilDateTimestamp = new Date(untilDateTime).getTime();

		//

		return localUntilDateTimestamp >= now || isOneOff;
	});

	futureClassEvents = futureClassEvents?.sort((a, b) => {
		const metafieldsA = a?.metafields?.filter((m) => {
			return m.namespace === 'meeting' && m.key === 'json';
		});

		const metafieldsJsonA = JSON.parse(metafieldsA[0].value);

		const meetingDateTimeA = metafieldsJsonA.meeting_date_time || '';

		const localMeetingDateTimestampA = new Date(meetingDateTimeA).getTime();

		const metafieldsB = b?.metafields?.filter((m) => {
			return m.namespace === 'meeting' && m.key === 'json';
		});

		const metafieldsJsonB = JSON.parse(metafieldsB[0].value);

		const meetingDateTimeB = metafieldsJsonB.meeting_date_time || '';

		const localMeetingDateTimestampB = new Date(meetingDateTimeB).getTime();

		return localMeetingDateTimestampB - localMeetingDateTimestampA;
	});

	const mainMetafields = mainProduct?.metafields?.filter((m) => {
		return m.namespace === 'meeting' && m.key === 'json';
	});

	const mainMetafieldsJson =
		mainMetafields?.length > 0 ? JSON.parse(mainMetafields[0].value) : {};

	//

	if (mainMetafieldsJson.is_series) {
		isSeriesProduct = true;
	}

	//

	const productDescription = mainProduct?.body_html;

	const freeProduct =
		(mainProduct?.price_max && mainProduct?.price_max === '0.00') ||
		mainProduct?.price_max === 0
			? true
			: false;

	useEffect(() => {
		if (mainMetafieldsJson) {
			const timeZone = mainMetafieldsJson.timezone;

			let timeZoneFormatted;

			if (timeZone && timeZone !== '') {
				if (
					timeZone === 'CT' ||
					timeZone === 'CST' ||
					timeZone === 'CDT'
				) {
					timeZoneFormatted = 'America/Chicago';
				} else if (
					timeZone === 'ET' ||
					timeZone === 'EST' ||
					timeZone === 'EDT'
				) {
					timeZoneFormatted = 'America/New_York';
				} else if (
					timeZone === 'MT' ||
					timeZone === 'MST' ||
					timeZone === 'MDT'
				) {
					timeZoneFormatted = 'America/Denver';
				} else if (
					timeZone === 'PT' ||
					timeZone === 'PST' ||
					timeZone === 'PDT'
				) {
					timeZoneFormatted = 'America/Los_Angeles';
				} else {
					timeZoneFormatted = timeZone;
				}
			}

			let newTimeOptions = {
				...timeOptions,
				// timeZone: timeZoneFormatted,
			};

			//

			setTimeOptions(newTimeOptions);

			//
			setProductMeta({
				...productMeta,
				isMain: true,
				comingSoon: mainMetafieldsJson.coming_soon || false,
				freePurchase: mainMetafieldsJson.free_purchase || false,
				freeSelect: mainMetafieldsJson.free_select || false,
				paidExternal: mainMetafieldsJson.paid_external || false,
				oneOff: mainMetafieldsJson.one_off || false,
				IGLive: mainMetafieldsJson.ig_live || false,
				noReg: mainMetafieldsJson.noreg || false,
				isEvent: mainMetafieldsJson.is_event || false,
				inPerson: mainMetafieldsJson.in_person || false,
				inPersonLocation: mainMetafieldsJson.in_person_location || '',
				inPersonVenue: mainMetafieldsJson.in_person_venue || '',
				inPersonAddress: mainMetafieldsJson.in_person_address || '',
				inPersonAddress2: mainMetafieldsJson.in_person_address_2 || '',
				inPersonCity: mainMetafieldsJson.in_person_city || '',
				inPersonState: mainMetafieldsJson.in_person_state || '',
				inPersonZip: mainMetafieldsJson.in_person_zip || '',
				virtual: mainMetafieldsJson.in_person ? false : true,
				isSeries: mainMetafieldsJson.is_series || false,
				seriesStartDate: mainMetafieldsJson.series_start_date || '',
				seriesEndDate: mainMetafieldsJson.series_end_date || '',
				meetingDate: mainMetafieldsJson.meeting_date || '',
				meetingDateTime: mainMetafieldsJson.meeting_date_time || '',
				dateTimeString: mainMetafieldsJson.date_time_string || '',
				meetingDateTimeFormatted:
					new Date(
						mainMetafieldsJson.meeting_date_time
					).toLocaleString('en-US', timeOptions) || '',
				untilDateTime: mainMetafieldsJson.until_date_time || '',
				dayOfWeek: mainMetafieldsJson.day_of_the_week || '',
				duration: mainMetafieldsJson.duration || '1 hour',
				meetingUrl: mainMetafieldsJson.meeting_url || '',
				meetingId: mainMetafieldsJson.meeting_id || '',
				profilePage1: mainMetafieldsJson.profile_page_1 || '',
				profilePage2: mainMetafieldsJson.profile_page_2 || '',
			});
		}
	}, []);

	//

	const handleClassSelect = (e) => {
		// )
		if (
			e.target.value === 'null' ||
			e.target.value === '' ||
			!e.target.value
		) {
			setSelectedClass({});
			setProductMeta(initialMeta);
			return;
		}
		const selectedClass = JSON.parse(e.target.value);

		//

		// be sure to stringify the object before setting it to state
		setSelectedClass(JSON.stringify(selectedClass));

		const selectedClassMetafields = selectedClass?.metafields?.filter(
			(m) => {
				return m.namespace === 'meeting' && m.key === 'json';
			}
		);

		const selectedClassMetafieldsJson =
			selectedClassMetafields?.length > 0
				? JSON.parse(selectedClassMetafields[0].value)
				: {};

		//

		if (selectedClassMetafieldsJson) {
			const timeZone = selectedClassMetafieldsJson.timezone;

			let timeZoneFormatted;

			if (timeZone && timeZone !== '') {
				if (
					timeZone === 'CT' ||
					timeZone === 'CST' ||
					timeZone === 'CDT'
				) {
					timeZoneFormatted = 'America/Chicago';
				} else if (
					timeZone === 'ET' ||
					timeZone === 'EST' ||
					timeZone === 'EDT'
				) {
					timeZoneFormatted = 'America/New_York';
				} else if (
					timeZone === 'MT' ||
					timeZone === 'MST' ||
					timeZone === 'MDT'
				) {
					timeZoneFormatted = 'America/Denver';
				} else if (
					timeZone === 'PT' ||
					timeZone === 'PST' ||
					timeZone === 'PDT'
				) {
					timeZoneFormatted = 'America/Los_Angeles';
				} else {
					timeZoneFormatted = timeZone;
				}
			}

			let newTimeOptions = {
				...timeOptions,
				timeZone: timeZoneFormatted,
			};

			setTimeOptions(newTimeOptions);

			setProductMeta({
				...productMeta,
				isMain: true,
				comingSoon: selectedClassMetafieldsJson.coming_soon || false,
				freePurchase:
					selectedClassMetafieldsJson.free_purchase || false,
				freeSelect: selectedClassMetafieldsJson.free_select || false,
				paidExternal:
					selectedClassMetafieldsJson.paid_external || false,
				oneOff: selectedClassMetafieldsJson.one_off || false,
				IGLive: selectedClassMetafieldsJson.ig_live || false,
				noReg: selectedClassMetafieldsJson.noreg || false,
				isEvent: selectedClassMetafieldsJson.is_event || false,
				inPerson: selectedClassMetafieldsJson.in_person || false,
				inPersonLocation:
					selectedClassMetafieldsJson.in_person_location || '',
				inPersonVenue:
					selectedClassMetafieldsJson.in_person_venue || '',
				inPersonAddress:
					selectedClassMetafieldsJson.in_person_address || '',
				inPersonAddress2:
					selectedClassMetafieldsJson.in_person_address_2 || '',
				inPersonCity: selectedClassMetafieldsJson.in_person_city || '',
				inPersonState:
					selectedClassMetafieldsJson.in_person_state || '',
				inPersonZip: selectedClassMetafieldsJson.in_person_zip || '',
				virtual: selectedClassMetafieldsJson.in_person ? false : true,
				isSeries: selectedClassMetafieldsJson.is_series || false,
				seriesStartDate:
					selectedClassMetafieldsJson.series_start_date || '',
				seriesEndDate:
					selectedClassMetafieldsJson.series_end_date || '',
				meetingDate: selectedClassMetafieldsJson.meeting_date || '',
				meetingDateTime:
					selectedClassMetafieldsJson.meeting_date_time || '',
				dateTimeString:
					selectedClassMetafieldsJson.date_time_string || '',
				meetingDateTimeFormatted:
					new Date(
						selectedClassMetafieldsJson.meeting_date_time
					).toLocaleString('en-US', timeOptions) || '',
				untilDateTime:
					selectedClassMetafieldsJson.until_date_time || '',
				dayOfWeek: selectedClassMetafieldsJson.day_of_the_week || '',
				duration: selectedClassMetafieldsJson.duration || '1 hour',
				meetingUrl: selectedClassMetafieldsJson.meeting_url || '',
				meetingId: selectedClassMetafieldsJson.meeting_id || '',
				profilePage1: selectedClassMetafieldsJson.profile_page_1 || '',
				profilePage2: selectedClassMetafieldsJson.profile_page_2 || '',
			});
		}
	};

	const handleAddToCart = async (e) => {
		e.preventDefault();

		const classSelect = document.getElementById('class-select');

		let selectedClassObj = JSON.parse(selectedClass);

		//

		const selectedClassMetafields = selectedClassObj?.metafields?.filter(
			(m) => {
				return m.namespace === 'meeting' && m.key === 'json';
			}
		);

		//

		const selectedClassMetafieldsJson =
			selectedClassMetafields?.length > 0
				? JSON.parse(selectedClassMetafields[0].value)
				: {};

		//

		const timeZone = selectedClassMetafieldsJson.timezone;

		if (timeZone && timeZone !== '') {
			if (timeZone === 'CT') {
				timeOptions.timeZone = 'America/Chicago';
			} else if (timeZone === 'ET') {
				timeOptions.timeZone = 'America/New_York';
			} else {
				timeOptions.timeZone = timeZone;
			}
		}

		let dateTime = new Date(selectedClassMetafieldsJson.meeting_date_time);

		// dateTime =
		//     new Date(
		//         selectedClassMetafieldsJson.meeting_date_time
		//     ).toLocaleString('en-US', timeOptions) || ''

		// if (timeZone && timeZone === 'ET') {

		//     dateTime = addHours(new Date(
		//         selectedClassMetafieldsJson.meeting_date_time
		//     ), -1)
		// }

		dateTime = dateTime.toLocaleString('en-US', timeOptions) || '';

		function addHours(date, hours) {
			date.setTime(date.getTime() + hours * 60 * 60 * 1000);
			return date;
		}

		const dayOfWeek = selectedClassMetafieldsJson.day_of_the_week || '';

		const dateTimeString = selectedClassMetafieldsJson.date_time_string;

		//

		if (dateTime && dateTime === 'Invalid Date') {
			dateTime = dayOfWeek + 's';
		}

		let cartId = $cartData.cartId || '';
		let variantId = selectedClassObj?.variants[0]?.id || '';

		const product = `gid://shopify/ProductVariant/${variantId}`;

		let lines = {
			merchandiseId: product,
			quantity: 1,
			attributes: [
				{
					key: 'Date',
					value: `${dateTimeString}`,
				},
			],
		};

		//

		if (!cartId || cartId === '') {
			let cartCreateData = await createCart();
			cartId = cartCreateData.data.cartId;

			//

			let cartObj = {
				...cartData.get(),
				cartId: cartId,
				checkoutUrl: cartCreateData.data.checkoutUrl,
			};

			cartData.set(cartObj);

			//

			addToCart(cartId, lines).then((addToCartData) => {
				//
				let cartLines =
					addToCartData.body?.cartLinesAdd?.cart?.lines?.edges;
				let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost;
				let discountCodes =
					addToCartData?.body?.cartLinesAdd?.discountCodes;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
					discountCodes: discountCodes,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				chord.trackProductAdded({
					cart: $cartData,
					product: {
						product: selectedClassObj,
						quantity: 1,
						variantId,
					},
				});

				setTimeout(() => {
					// reset class select on add to cart
					classSelect.selectedIndex = 0;
					setSelectedClass({});
					setProductMeta(initialMeta);
				}, 100);
			});
		} else {
			//

			addToCart(cartId, lines).then((addToCartData) => {
				//

				let cartLines =
					addToCartData.body?.cartLinesAdd?.cart?.lines?.edges;
				let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost;
				let discountCodes =
					addToCartData?.body?.cartLinesAdd?.discountCodes;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
					discountCodes: discountCodes,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				chord.trackProductAdded({
					cart: $cartData,
					product: {
						product: selectedClassObj,
						quantity: 1,
						variantId,
					},
				});

				setTimeout(() => {
					// reset class select on add to cart
					classSelect.selectedIndex = 0;
					setSelectedClass({});
					setProductMeta(initialMeta);
				}, 100);
			});
		}
	};

	//
	//

	useEffect(() => {
		let options = document.getElementById('class-select')?.options;
		let nullOption;
		//
		if (!options) {
			return;
		}

		for (let i = 0; i < options.length; i++) {
			let option = options[i];
			//
			if (option.value.indexOf('[hidden]')) {
				nullOption = option;
			}
		}

		//

		// if (nullOption) {
		//     nullOption.setAttribute('disabled', 'disabled')
		//     nullOption.setAttribute('hidden', 'hidden')
		// }
	}, []);

	//

	useEffect(() => {
		chord.trackProductViewed({
			cart: $cartData,
			product: {
				product: mainProduct,
				quantity: 1,
			},
		});
	}, []);

	return (
		<div className='classes-product-outer main-product wrap-xl mx-auto mt-6 mb-8'>
			<div className='classes-product-inner flex flex-col mx-auto'>
				{mainProduct ? (
					<div className='product-wrap p-6 bg-[#f8f8f8] flex justify-center flex-wrap lg:flex-nowrap mx-auto'>
						<div className='product-images-outer w-full lg:w-5/12'>
							<div className='product-images-inner'>
								<img
									src={mainProduct.images_info[0]?.src}
									alt={mainProduct.images_info[0]?.alt}
								/>
							</div>
						</div>
						<div className='product-content-outer w-full lg:w-7/12 lg:ml-6 bg-white p-6 flex flex-col'>
							<div className='product-header pb-3 border-b border-oat'>
								<div className='product-above-title flex w-full'>
									<div className='product-flags mb-3'>
										{productMeta.inPerson ? (
											<div className='product-flag in-person flex items-center'>
												<span className='text-xs'>
													In Person:
													<span>&nbsp;</span>
												</span>
												<span className='text-xs text-flint font-normal'>
													{
														productMeta.inPersonLocation
													}
												</span>
											</div>
										) : (
											<div className='product-flag virtual flex items-center'>
												<span className='text-xs'>
													Virtual
												</span>
											</div>
										)}
									</div>
								</div>
								<div className='product-title-price flex w-full'>
									<h1 className='product-title text-2xl w-full lg:w-2/3 leading-tight'>
										{mainProduct.title
											.split('_')[0]
											.replace('[hidden]', '')}
									</h1>
									{!productMeta.paidExternal ? (
										<div className='product-price text-2xl lg:w-1/3 ml-auto text-right'>
											{(mainProduct.price_max &&
												mainProduct.price_max ===
													'0.00') ||
											mainProduct.price_max === 0 ? (
												<span className='price'>
													Free
												</span>
											) : (
												<span className='price'>
													$
													{mainProduct.price_max?.toFixed(
														2
													)}
												</span>
											)}
										</div>
									) : null}
								</div>
								{productMeta.dayOfWeek &&
								!productMeta.oneOff ? (
									<div className='product-day-of-week text-sm text-flint font-normal my-2'>
										{mainProduct?.title.includes(
											'Baby Bandstand'
										)
											? 'Wednesdays & '
											: ''}
										{productMeta.dayOfWeek}s
									</div>
								) : null}

								{productMeta.oneOff &&
								productMeta.dateTimeString &&
								productMeta.dateTimeString !==
									'Invalid Date' ? (
									<div className='product-date text-flint font-normal mt-3'>
										{productMeta.dateTimeString}
									</div>
								) : null}
							</div>

							<div className='product-description font-normal text-sm prose pt-3'>
								{parse(productDescription)}
							</div>
							{futureClassEvents?.length > 0 &&
							!productMeta.oneOff &&
							!productMeta.paidExternal ? (
								<div className='product-select my-3'>
									<label className='mt-2 mb-1 text-xs md:text-sm'>
										{!selectedClass ||
										isEmpty(selectedClass)
											? `Please select a class${
													productMeta.freeSelect
														? ' to register'
														: ''
											  }:`
											: 'Selected class:'}

										<select
											id='class-select'
											value={selectedClass}
											className='select-class border border-oat p-3 w-full'
											onChange={(e) =>
												handleClassSelect(e)
											}
										>
											<option
												value={JSON.stringify(null)}
											>
												-- Select a class --
											</option>
											{futureClassEvents
												?.reverse()
												.map((p) => {
													//

													const metafields =
														p?.metafields?.filter(
															(m) => {
																return (
																	m.namespace ===
																		'meeting' &&
																	m.key ===
																		'json'
																);
															}
														);
													const metafieldsJson =
														metafields?.length > 0
															? JSON.parse(
																	metafields[0]
																		.value
															  )
															: {};

													//

													//

													const timeZone =
														metafieldsJson.timezone;

													const meetingDateTime =
														metafieldsJson.meeting_date_time ||
														'';

													const localMeetingDateTime =
														new Date(
															meetingDateTime
														).toLocaleString(
															'en-US',
															timeOptions
														);
													const dateTimeString =
														metafieldsJson.date_time_string;
													const meetingDateTimeFormatted =
														productMeta.meetingDateTimeFormatted;
													const isSeries =
														metafieldsJson.is_series;

													const inPerson =
														metafieldsJson.in_person;

													const inPersonCity =
														metafieldsJson.in_person_city;

													//

													const seriesStartDate =
														metafieldsJson.series_start_date;
													const seriesEndDate =
														metafieldsJson.series_end_date;

													const dayOfWeek =
														metafieldsJson.day_of_the_week;
													//
													if (
														!p.title.includes(
															'[hidden]'
														)
													) {
														return (
															<option
																id={p.id}
																key={p.id}
																value={JSON.stringify(
																	p
																)}
																data-variant-id={
																	p
																		.variants[0]
																		.id
																}
															>
																{dateTimeString &&
																dateTimeString !==
																	'Invalid Date'
																	? dateTimeString
																		? dateTimeString
																		: localMeetingDateTime
																	: (isSeries &&
																			isSeries !==
																				0) ||
																	  (isSeries &&
																			isSeries !==
																				'0' &&
																			!localMeetingDateTime)
																	? dayOfWeek +
																	  's' +
																	  ' - ' +
																	  seriesStartDate +
																	  ' to ' +
																	  seriesEndDate
																	: null}
															</option>
														);
													}
												})}
										</select>
									</label>
								</div>
							) : null}
							{futureClassEvents?.length > 0 &&
							!productMeta.oneOff &&
							!productMeta.freeSelect &&
							!productMeta.paidExternal ? (
								<div className='product-actions product-actions-outer product-actions-atc py-6'>
									<div className='product-add-to-cart w-full'>
										<Fragment>
											<input
												type='hidden'
												min='1'
												name='quantity'
												value='1'
											/>
											<input
												type='hidden'
												name='id'
												id='variant-id'
												value={
													selectedClass &&
													selectedClass?.variants
														?.length > 0
														? selectedClass
																.variants[0].id
														: ''
												}
											/>
										</Fragment>
										<Fragment>
											{isSeriesProduct ? (
												<button
													type={`${
														!isEmpty(
															selectedClass
														) &&
														!productMeta.dayOfWeek
															? null
															: 'submit'
													}`}
													className={`large-button series-button button-atc w-full !h-[60px] ${
														isEmpty(selectedClass)
															? 'disabled noclick !opacity-30'
															: 'hover:bg-ash opacity-100'
													}`}
													// data-balloon-blunt
													data-balloon-pos='up'
													aria-label={
														isEmpty(selectedClass)
															? 'Please select a class to add to cart'
															: null
													}
													onClick={(e) =>
														handleAddToCart(e)
													}
												>
													Add To Cart
												</button>
											) : null}

											{!isSeriesProduct &&
											!productMeta.freeSelect &&
											!productMeta.paidExternal &&
											!isEmpty(selectedClass) ? (
												<button
													type={`${
														!productMeta.meetingDateTime
															? null
															: 'submit'
													}`}
													className={`large-button button-atc w-full !h-[60px] ${
														!productMeta.meetingDateTime
															? 'disabled noclick !opacity-30'
															: 'hover:bg-ash opacity-100'
													}`}
													// data-balloon-blunt
													data-balloon-pos='up'
													aria-label={
														!productMeta.meetingDateTime
															? 'Please select a class to add to cart'
															: null
													}
													onClick={(e) =>
														handleAddToCart(e)
													}
												>
													Add To Cart
												</button>
											) : null}
										</Fragment>

										{freeProduct &&
										!productMeta.freeSelect &&
										!isEmpty(selectedClass) ? (
											<p className='text-xs my-2 leading-tight font-normal'>
												To register for a free class,
												please click "Add to Cart" above
												and then continue through
												Checkout. You will not be
												charged.
											</p>
										) : null}
									</div>
								</div>
							) : null}

							{freeProduct &&
							productMeta.meetingUrl &&
							productMeta.meetingUrl !== '' &&
							productMeta.freeSelect &&
							isSeriesProduct === false ? (
								<div className='product-actions product-actions-outer py-6'>
									<a
										className='register-free large-button button-atc w-full !h-[60px] bg-flint !hover:bg-ash'
										href={productMeta.meetingUrl}
										target='_blank'
										rel='noopener noreferrer'
									>
										Register Now (Free)
									</a>
								</div>
							) : null}
							{productMeta ? (
								<div className='product-desc-accordion my-3 border-b border-slate'>
									<ClassesAccordion
										accordionData={productMeta}
									/>
								</div>
							) : null}
						</div>
					</div>
				) : (
					<div className='no-product'>
						<p>No product found</p>
					</div>
				)}
				{productMeta.profilePage1 &&
				productMeta.profilePage1.length &&
				productMeta.profilePage1 !== '[]' ? (
					<Expert
						profile1={productMeta.profilePage1}
						profile2={productMeta.profilePage2}
					/>
				) : null}
			</div>
			{slug && slug !== null && slug !== '' ? (
				<div className='products-outer my-12'>
					<div className='products-inner'>
						<Carousel carouselData={babyCategories} />
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ClassesProduct;
